/**
 * Leave, as data (Oct 2026) -- the twin of src/logic/leave.py.
 *
 *   employee.leave = { "2026-10-05": "full", "2026-10-06": "AM" }
 *
 * One entry per calendar date, whose value is "full", "AM" or "PM". It used
 * to be a list of strings ("2026-10-05", "2026-10-05_AM", "2026-10-05 AM")
 * that every screen took apart again; the server now reads those once, at
 * load, and this module is the only reader on this side.
 */
export const PARTS = ['full', 'AM', 'PM'];

const ISO = /^\d{4}-\d{2}-\d{2}$/;

/** The person's leave map ({} for none). */
export const leaveOf = (emp) => (emp && typeof emp.leave === 'object' && emp.leave) || {};

/** "full", "AM", "PM" -- or null when the person has no leave that day. */
export const partOn = (emp, iso) => {
  const part = leaveOf(emp)[iso];
  return PARTS.includes(part) ? part : null;
};

/** Any leave on `iso` (no half), or leave covering that half ("AM" / "PM"). */
export const onLeave = (emp, iso, half) => {
  const part = partOn(emp, iso);
  if (!part) return false;
  return !half || part === 'full' || part === half;
};

/** Every date the person has leave on. */
export const leaveDates = (emp) => Object.keys(leaveOf(emp)).filter((d) => ISO.test(d) && partOn(emp, d));

/** The free-text leave type for a date ("Annual Leave"), or null. */
export const leaveLabel = (emp, iso) => (emp?.leave_labels || emp?.leaveLabels || {})[iso] || null;
